import * as preloadUtilities from '@alme/ui-web/ref/utilities-preload';
import { instantiateClient, getClientInstance } from './client-instance.js';
import { getSettings, overrideSettings, removeSettings } from '@alme/ui-web/settings/settings-util';
import otherSettings from '../settings/settings';
import settingsToRemove from '../settings/remove';
require('../styles/themes/_theme_default.scss');
import accessibilitySettings from '../settings/accessibility';
import analyticsSettings from '../settings/analytics';
import appeventSettings from '../settings/appevent-constants';
import classNames from '../settings/class-names.js';
import contactUsPageSettings from '../settings/contact-us-page';
import elementDisablerSettings from '@alme/ui-web/settings/element-disabler';
import footerLinksSettings from '../settings/footer-links';
import formIntegrationSettings from '../settings/form-integration';
import navSettings from '../settings/nav-constants';
import responseActionSettings from '../settings/response-action-constants';
import stateLocations from '../settings/state-locations'; 
import textSettings from '../settings/text-constants'; 
import windowSettings from '../settings/window';
import { checkInjectTarget } from './util.js';
import ivaAvailabilitySettings from '../settings/iva-availability.ts';
import { messageConstants } from '../settings/message-constan';
import  { Error } from '../settings/error';
import  { liveChatSetting } from '../settings/live-chat';
import { stateTriggers} from '../settings/state-triggers.ts';

let settingsToOverride = {
    version: process.env.VERSION,
    ...liveChatSetting,
    ...otherSettings,
    ...accessibilitySettings,
    ...analyticsSettings,
    ...appeventSettings,
    ...classNames,
    ...elementDisablerSettings,
    ...footerLinksSettings,
    ...formIntegrationSettings,
    ...navSettings,
    ...responseActionSettings,
    ...stateLocations,
    ...textSettings,
    ...ivaAvailabilitySettings,
    ...windowSettings, 
    ...messageConstants,   
    ...Error,
    ...stateTriggers,
};

const { onContactUsPage } = checkInjectTarget(getSettings().Window.rootId);

if(onContactUsPage){

    settingsToOverride = {
        ...settingsToOverride,
        ...contactUsPageSettings,
    };
}

overrideSettings(settingsToOverride);
removeSettings(settingsToRemove);

const settings = getSettings();

preloadUtilities.injectAgentContainer(settings.Window.rootId);

instantiateClient(settings, onContactUsPage);

const almeWebClient = getClientInstance();
almeWebClient.initialize();
almeWebClient.start();
export { almeWebClient };


// WEBPACK FOOTER //
// ./src/implementation.js